<script lang="ts">
	import type { SiteConfig } from '$lib/types';
	import Fingerprint from './Fingerprint.svelte';

	interface Props {
		site: SiteConfig;
	}

	let { site }: Props = $props();

	const steps = [
		{
			title: 'Get the signed material',
			body: 'Keep the email, message, or file exactly as you received it, including any separate signature that came with it.'
		},
		{
			title: 'Fetch the public key',
			body: 'Download the key published on this site. A download is not proof by itself — the fingerprint is what you compare.'
		},
		{
			title: 'Verify in your software',
			body: 'Import the key, confirm the fingerprint, then use your OpenPGP software to check the signature. This site does not verify signatures in the browser.'
		}
	];
</script>

<section id="verify" class="section verify" aria-labelledby="verify-heading">
	<div class="container">
		<div class="section-intro verify-intro">
			<p class="eyebrow">{site.verify.eyebrow}</p>
			<h2 id="verify-heading">{site.verify.title}</h2>
			<div class="section-rule" aria-hidden="true"></div>
			<p class="section-subtitle">{site.verify.lead}</p>
		</div>

		<ol class="workflow">
			{#each steps as step, index (step.title)}
				<li class="workflow-step">
					<span class="workflow-index" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span
					>
					<div class="workflow-body">
						<h3>{step.title}</h3>
						<p>{step.body}</p>
					</div>
				</li>
			{/each}
		</ol>

		<div class="verify-panel">
			<Fingerprint fingerprint={site.pgp.fingerprint} />
			<div class="verify-actions">
				<a class="button button-primary" href={site.pgp.path}>Download public key</a>
				<a class="button button-secondary" href="/verify">How to verify</a>
			</div>
		</div>
	</div>
</section>
